import { MainCtaButton } from "../../components/MainCtaButton";

export const BottomCTA = ({ data }) => {
  return (
    <section className="bottom_cta-background">
      <section className="section-layout">
        <article className="bottom_cta-text">
          <p className="bottom_cta-head">{data.head}</p>
          <section className="bottom_cta-buttons">
            <MainCtaButton section="Discover-and-Deploy" />
          </section>
        </article>
      </section>
    </section>
  );
};
